import React from "react";
import { Helmet } from "react-helmet";
import "./ParentComp.css";

import HeaderPage from "./HeaderPage";
import LearningTopics from "./LearningTopics";
import SectionTwo from "./SectionTwo";
import CourseModules from "./Module";
import MentorProfile from "./MentorProfile";
import CertificateSection from "./CertificateSection";
import BonusOffer from "./BonusOffer";
import TestimonialTwo from "./TestimonialTwo";
import FAQSection from "./FAQSection";
import CareerPath from "./CareerPath";
import CourseModuless from "./CourseModules";
import AITools from "./AITools";
import PlacementPartners from "./PlacementPartners";
import InquiryForm from "./InquiryForm";
import CareerCard from "./CareerCard";

const ParentComp = () => {
  return (
    <>
      <Helmet>
        <title>Digital Marketing Course by Arrow | Learn SEO, Social Media, AI Tools & More</title>
        <meta
          name="description"
          content="Join Arrow Digital's comprehensive Digital Marketing Course. Learn SEO, Google Ads, Social Media Marketing, AI Tools, and get job-ready with certifications and real placements."
        />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://arrowdigitalmarketing.com/course" />

        {/* Open Graph Tags */}
        <meta property="og:title" content="Arrow Digital Marketing Course | Learn from Industry Experts" />
        <meta
          property="og:description"
          content="Master Digital Marketing with our industry-led training program. Includes SEO, Google Ads, Meta Ads, AI tools & job placement support."
        />
        <meta property="og:url" content="https://arrowdigitalmarketing.com/courses" />
        <meta property="og:image" content="https://arrowdigitalmarketing.com/course-preview.jpg" />
        <meta property="og:type" content="website" />

        {/* Twitter Card Tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Digital Marketing Course by Arrow | Job Oriented Training" />
        <meta
          name="twitter:description"
          content="Become a Digital Marketing Pro with Arrow. Get certified, use AI tools, and unlock your career with placement assistance."
        />
        <meta name="twitter:image" content="https://arrowdigitalmarketing.com/course-preview.jpg" />
      </Helmet>

      <div>
        <HeaderPage />
        <LearningTopics />
        <SectionTwo />
        <CourseModules />
        <CourseModuless />
        <AITools />
        <CareerCard />
        <MentorProfile />
        <CertificateSection />
        <PlacementPartners />
        <BonusOffer />
        <TestimonialTwo />
        <CareerPath />
        <InquiryForm />
        <FAQSection />
      </div>
    </>
  );
};

export default ParentComp;
